"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Stack = _interopRequireDefault(require("../Stack"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _styles = require("@mui/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["fullHeight", "noMatchesLabel", "noResultsLabel", "notInitedLabel", "inited", "filtered", "className"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var useStyles = (0, _styles.makeStyles)({
  root: {
    height: function height(_ref) {
      var fullHeight = _ref.fullHeight;
      return fullHeight ? '100%' : 'fit-content';
    },
    width: '100%'
  }
}, {
  name: 'GgNoResults'
});
var NoResults = function NoResults(props) {
  var _props$fullHeight = props.fullHeight,
    fullHeight = _props$fullHeight === void 0 ? true : _props$fullHeight,
    _props$noMatchesLabel = props.noMatchesLabel,
    noMatchesLabel = _props$noMatchesLabel === void 0 ? 'No matches found' : _props$noMatchesLabel,
    _props$noResultsLabel = props.noResultsLabel,
    noResultsLabel = _props$noResultsLabel === void 0 ? 'No records' : _props$noResultsLabel,
    notInitedLabel = props.notInitedLabel,
    _props$inited = props.inited,
    inited = _props$inited === void 0 ? false : _props$inited,
    _props$filtered = props.filtered,
    filtered = _props$filtered === void 0 ? false : _props$filtered,
    className = props.className,
    other = _objectWithoutProperties(props, _excluded);
  var classes = useStyles({
    fullHeight: fullHeight
  });
  var labelToDisplay = (0, _react.useMemo)(function () {
    var label = notInitedLabel;
    if (inited) {
      label = noResultsLabel;
    }
    if (filtered) {
      label = noMatchesLabel;
    }
    return label;
  }, [noMatchesLabel, noResultsLabel, notInitedLabel, inited, filtered]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack["default"], _objectSpread(_objectSpread({
    className: (0, _clsx["default"])(className, classes.root),
    justifyContent: 'center'
  }, other), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
      align: 'center',
      color: 'textSecondary',
      children: labelToDisplay
    })
  }));
};
var _default = exports["default"] = NoResults;
NoResults.propTypes = {
  fullHeight: _propTypes["default"].bool,
  noMatchesLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  noResultsLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  notInitedLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  inited: _propTypes["default"].bool,
  filtered: _propTypes["default"].bool
};